// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__iri1p","readMore":"styles_readMore__Hsfjn","blocked":"styles_blocked__y4O8r","mask":"styles_mask__Vdi7_","showMoreButton":"styles_showMoreButton__0gqv7"};